(function() {
  document.addEventListener('DOMContentLoaded', function() {
    const learnHeader = document.querySelector('.learn-header');
    if (!learnHeader) return;

    let lastScrollY = window.scrollY;
    let ticking = false;
    const threshold = 125;

    function updateHeader() {
      const currentScrollY = window.scrollY;

      if (currentScrollY <= threshold) {
        // 靠近顶部，恢复默认（125px）
        learnHeader.classList.remove('learn-header--top-zero');
      } else if (currentScrollY > lastScrollY) {
        // 向下滑：吸顶
        learnHeader.classList.add('learn-header--top-zero');
      } else if (currentScrollY < lastScrollY) {
        // 向上滑：退回 125px
        learnHeader.classList.remove('learn-header--top-zero');
      }

      lastScrollY = currentScrollY;
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });
  });
})();